import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../Layout';
import { Breadcrumb, Input, Table, Pagination, ConfigProvider, notification, Flex, Button } from 'antd';
import type { TableColumnsType, TableProps } from 'antd';
import useToast from '../../hook/useToast';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import {
  EyeOutlined, EditOutlined,
  DeleteOutlined,
  DownOutlined,
  CloseCircleOutlined,
  MinusOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import type { SearchProps } from 'antd/es/input/Search';
import viVN from 'antd/locale/vi_VN';
import { Link } from 'react-router-dom';
import './PoolingDataAuto.scss'
import PopupShowData from './ComponentPoolingData/PopupShowData';
import { mixGetV2, mixDate, mixPostV2, formatNumber, mixGetV1 } from '../../services/mixin'
import ModalDeleteManager from '../../components/ModalDeleteManager';
import MegaTable from '../../components/MagaTableV2';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { selectorUnitByUserPermission } from '../../store/slices/UnitByUserPermission';
import { selectorSourceColumnWarehouse } from '../../store/slices/sourceColumnWarehouseSlice';
import { useSelector } from 'react-redux';

const PoolingDataAutoDetail: React.FC = () => {

  const user = useSelector(selectorInfoUser);
  const unitByUserPermission = useSelector(selectorUnitByUserPermission);
  const sourceColumnWarehouse = useSelector(selectorSourceColumnWarehouse);
  useEffect(() => {
    const findData = unitByUserPermission.find(x => x.unitId === user.unitTemp) as any
    setParamListData((prev) => ({ ...prev, branch_code: findData ? findData.unitCode : '', reload: true }))
  }, [user, unitByUserPermission]);

  useEffect(() => {
    document.title = 'THACO AUTO CRM';
  }, []);
  const pushToast = useToast();
  const navigate = useNavigate()
  // State
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.customer_dup?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCachePoolingDataAuto',
    col: [
      {
        headerName: 'Hành động',
        field: 'action',
        width: 100,
        resizable: false,
        sortable: false,
        filter: false,
        lockPosition: 'left',
        order: -9999,
        cellRenderer: (params: any) => {
          return (
            <div className='list-action-icon'>
              <Link className='action-ctr' to={`/customer/pooling-data/customer-list/manual-data-merging?migration=${params.data.idMigration}&ids=${params.data.list_cus_ids.join(',')}&list_key=${params.data.list_key}`} title="Xem chi tiết">
                <EyeOutlined />
              </Link>
            </div>
          )
        },
      },
      ...tableColumns(sourceColumnWarehouse)
    ],
    listData: [],
    showSetting: false,
    loading: true,
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onChangeTB: TableProps['onChange'] = (pagination, filters, sorter, extra) => {

  };

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = () => {
    api['success']({
      message: 'Tạo Voucher thành công!',
      placement: 'bottomRight',
      className: 'single-message'
    });
  };

  const [showSelectFilter, setActive] = useState(false);
  const [isShowSelect, setShowSelect] = useState('Chọn điều kiện');
  const [dasData, setDasData] = useState({
    total_duplicate_groups: 0,
    percentage_of_total_customers: 0,
  } as any);
  const handleClearFilter = (isShow: any) => {
    setActive(false)
    setShowSelect(isShow)
  }

  // const [loading, setLoading] = useState(false);
  const [selectedRowKeysV2, setSelectedRowKeysV2] = useState([] as any);
  const deleteItems = () => {
    if (listDataLoading) {
      return
    }
    if (selectedRowKeys.length === 0) {
      pushToast('Chưa chọn dữ liệu xóa.', "warning")
      return
    } else {
      setOpenDeleteV2(true)
      setSelectedRowKeysV2([...JSON.parse(JSON.stringify(selectedRowKeys))])
    }
  };

  // Get columns
  const [columns, setColumns] = useState([] as any)
  let wait3 = false
  const getcolumn = async () => {
    if (wait3) {
      return
    }
    wait3 = true
    const res = await mixGetV2('/api/v1/be/source_column_warehouses?is_active=1')
    wait3 = false
    if (res.status) {
      const df = [
        {
          title: 'Hành động',
          dataIndex: '',
          align: 'center',
          render: (_: any, record: any) => (
            <>
              <div className="t-hd-table">
                <div onClick={() => toDetail(record)} className="item-hd-table"><span><EyeOutlined /></span></div>
                <div onClick={() => toDelete(record)} className="item-hd-table t-cl-F5222D"><span><DeleteOutlined /></span></div>
              </div>
            </>
          ),
        },
      ] as any
      const resColum = [] as any
      res.data.items.map((val: any, index: any) => {
        resColum.push({ title: val.name, dataIndex: val.column_warehouse.column, key: val.id, hidden: true })
        return true
      })
      setColumns([...df, ...resColum, {
        title: 'Trạng thái',
        dataIndex: 'is_merged',
        align: 'center',
        render: (_: any, record: any) => (
          <>
            <div className={`t-status ${record.is_merged === 1 ? 't-cl-0F9D58' : 't-cl-F5222D'}`}>
              {record.is_merged === 1 ? 'Đã gộp' : 'Chưa gộp'}
            </div>
          </>
        ),
      }])
    }
  }
  useEffect(() => {
    getcolumn()
  }, [])

  const [isStep, setStep] = useState(1);
  const [idMigration, setIdMigration] = useState(null as any)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const handleChangePagination = (current: number, pageSize: number) => {
    setPagination({ ...pagination, current, pageSize })
    setParamListData({ ...paramListData, limit: pageSize, page: current, reload: true })
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', current.toString());
    searchParams.set('pageSize', pageSize.toString());
    navigate(`?${searchParams.toString()}`, { replace: true });
  }
  const [paramListData, setParamListData] = useState({
    page: pagination.current,
    limit: pagination.pageSize,
    reload: false,
    idx: false,
    branch_code: null,
  })
  const [warehousesDuplicates, setWarehousesDuplicates] = useState([] as any);
  const [listDataLoading, setListDataLoading] = useState(true as any)
  const [filterfullname, setFilterfullname] = useState(true as any)

  const getUnitListForSearch = async (codeUnit = '') => {
    const res = await mixGetV1(`unit/getChildUnits?codeUnit=${codeUnit}`);
    wait3 = false
    if (res.status) {
      const listCodeUnit = res.data.map((item: any) => item.code)
      return listCodeUnit.join(',')
    }
  }
  const setActiveStep2 = async (idM = null as any, page = null as any, limit = null as any) => {
    let idMigrationData = idMigration
    if (idM) {
      idMigrationData = idM
    }
    setParamListData({ ...paramListData, reload: false })
    setMegaTableData((prev: any) => ({ ...prev, loading: true }));
    if (!idMigrationData) {
      pushToast("Chưa chọn điều kiện!", "error")
      return
    }
    if (!paramListData.reload) {
      setStep(2)
    }
    setListDataLoading(true)
    const listKey = [] as any
    const listunknow = [] as any
    const findData = listMigrations.find((x: any) => x.id === idMigrationData)
    if (findData) {
      findData.more_migration.map((val: any) => {
        listKey.push(val.key_params_tamp)
        listunknow.push(val.is_unknow)
      })
      const cols = megaTableData.col as any[]
      cols.map((val: any) => {
        if (listKey.includes(val.field)) {
          val.lockPosition = 'left'
          val.order = (listKey.length - listKey.indexOf(val.field)) * -1
        } else {
          if (val.field !== 'action') {
            delete val.lockPosition
            delete val.order
          }
        }
      })
      setMegaTableData((prev: any) => ({ ...prev, col: cols }));
    } else {
      pushToast("Không tìm thấy điều kiện!", "error")
      setListDataLoading(false)
      return
    }
    const params = {
      ...paramListData,
      list_key: listKey.join(','),
      unknowns: listunknow.join(','),
    } as any
    if (paramListData.branch_code) {
      const listCodeUnit = await getUnitListForSearch(paramListData.branch_code)
      params.branch_code = listCodeUnit
    }
    if (page && limit) {
      params.page = page
      params.limit = limit
    }
    delete params.reload
    delete params.idx
    const res = await mixGetV2('/api/v1/be/customer/get_duplicate_customers', params)
    setMegaTableData((prev: any) => ({ ...prev, loading: false }));
    if (res.status) {
      setDasData({ ...res.data.summary })
      const temp = [] as any;
      res.data.items.forEach((val: any) => {
        temp.push({
          ...val,
          key: val.id,
          list_key: listKey.join(','),
          idMigration: idMigrationData,
        })
      });
      setMegaTableData((prev: any) => ({ ...prev, listData: temp }));
      saveData()
      if (res.data.total > 0) {

        if (res.data.filter_fullname === 0) {
          setFilterfullname(false)
        }
        const dataSource = res.data.items.map((item: any, index: any) => ({
          ...item,
          id: index,
          idMigration
        }));
        const strkey = [] as any
        const item0 = {
          ...res.data.items[0]
        } as any
        Object.keys(item0).map((iskey: any) => {
          strkey.push(iskey)
          return true
        })
        const newcl = [] as any
        columns.map((val: any) => {
          if (strkey.includes(val.dataIndex)) {
            newcl.push({
              ...val,
              hidden: false
            })
          } else {
            newcl.push(val)
          }
          return true
        })
        setColumns(newcl)
        if (page && limit) {
          setPagination({ ...pagination, total: res.data.total, current: page, pageSize: limit })
        } else {
          setPagination({ ...pagination, total: res.data.total, current: paramListData.page, pageSize: paramListData.limit })
        }
        setWarehousesDuplicates(dataSource)
        if (!paramListData.reload) {
          setStep(3)
        }

        if (paramListData.idx) {
          setParamListData({ ...paramListData, idx: false, reload: false })
          setSelectedRowKeys([])
        }

        setListDataLoading(false)
      } else {
        pushToast("Hệ thống không tìm thấy dữ liệu khách hàng trùng lặp!", "warning")
        setStep(1)
      }
    } else {
      if (!paramListData.reload) {
        setStep(1)
      }
    }
  }

  useEffect(() => {
    if (paramListData.reload === true) {
      setActiveStep2()
    }
  }, [paramListData])

  // Lấy danh sách điều kiện gộp
  const [listMigrations, setListMigrations] = useState([] as any)
  let wait1 = false
  const getMigrations = async () => {
    if (wait1) {
      return
    }
    wait1 = true
    const res = await mixGetV2('/api/v1/be/data_migrations?sort[]=id,desc&limit=10000&page=1&is_active=1')
    wait1 = false
    if (res.status) {
      const items = res.data.items
      const temp = [] as any
      items.map((val: any) => {
        if (val.is_active === 1) {
          temp.push({
            value: val.id,
            label: val.name,
            ...val
          })
        }
        return true
      })
      setListMigrations([...temp])
    }
  }
  useEffect(() => {
    getMigrations()
  }, [])

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const migrationParam = searchParams.get('migration');
    if (migrationParam) {
      const foundMigration = listMigrations.find((m: any) => m.value === Number(migrationParam));
      const pagepage = searchParams.get('page');
      const pageSizepage = searchParams.get('pageSize');
      if (foundMigration) {
        setShowSelect(foundMigration.label);
        setIdMigration(Number(migrationParam));
        setActiveStep2(Number(migrationParam), pagepage, pageSizepage)
      }
    }
  }, [listMigrations]);


  const toDetail = (item: any) => {
    const idM = item.idMigration
    if (idM === null) {
      pushToast('Vui lòng chọn điều kiện', 'error')
      return
    }
    let temp = { ...item }
    delete temp.idMigration
    delete temp.id
    if (filterfullname === false) {
      delete temp.fullname
    }
    const data = [] as any
    Object.keys(temp).map((iskey: any) => {
      if (iskey !== 'is_merged') {
        data.push({
          key: iskey,
          value: temp[iskey],
        })
      }
      return true
    })
    sessionStorage.setItem('itemDup', JSON.stringify(data))
    sessionStorage.setItem('idMigration', idM)
    window.open('/customer/pooling-data/pooling-data-auto-detail', '_blank')
    // navigate('/customer/pooling-data/pooling-data-auto-detail')
  }

  const [openDelete, setOpenDelete] = useState(false)
  const [openDeleteV2, setOpenDeleteV2] = useState(false)

  const [itemDel, setItemDel] = useState('' as any)
  const toDelete = (item: any) => {
    setOpenDelete(true)
    const data = [] as any
    const temp = { ...item }
    delete temp.idMigration
    delete temp.id
    // if (filterfullname === false) {
    //   delete temp.fullname
    // }
    Object.keys(temp).map((iskey: any) => {
      data.push({
        key: iskey,
        value: temp[iskey],
      })
      return true
    })
    setItemDel(JSON.stringify(data))
  }
  const closeModalDelete = () => {
    setItemDel('')
    setOpenDelete(false)
  }
  const closeModalDeleteV2 = () => {
    setOpenDeleteV2(false)
  }
  const onConfirmDelete = async () => {
    const param = {
      data: itemDel
    }
    const res = await mixPostV2('/api/v1/be/delete_warehouse_duplicate', param)
    if (res.status) {
      pushToast('Xóa thành công', "success")
      closeModalDelete()
      setParamListData({ ...paramListData, reload: true })
    } else {
      pushToast('Error', "warning")
    }
  }
  const onConfirmDeleteV2 = async (index = 0 as any) => {
    setOpenDeleteV2(false)
    setListDataLoading(true)
    const data = [] as any
    let temp = {} as any
    let findData = warehousesDuplicates.find((x: any) => x.id === selectedRowKeysV2[index]);
    if (findData) {
      temp = { ...findData }
    } else {
      if (selectedRowKeysV2[index + 1]) {
        onConfirmDeleteV2(index + 1)
      } else {
        setListDataLoading(false)
      }
    }
    delete temp.idMigration
    delete temp.id
    // if (filterfullname === false) {
    //   delete temp.fullname
    // }
    Object.keys(temp).map((iskey: any) => {
      data.push({
        key: iskey,
        value: temp[iskey],
      })
      return true
    })
    const param = {
      data: JSON.stringify(data)
    }
    const res = await mixPostV2('/api/v1/be/delete_warehouse_duplicate', param)
    if (res.status) {
      if (!selectedRowKeysV2[index + 1]) {
        pushToast('Xóa thành công', "success")
        setParamListData({ ...paramListData, reload: true, idx: true })
        setListDataLoading(false)
      }
    } else {
      pushToast('Error', "warning")
    }
    if (selectedRowKeysV2[index + 1]) {
      onConfirmDeleteV2(index + 1)
    } else {
      setListDataLoading(false)
    }
  }

  const saveData = async () => {
    return
    if (!idMigration) {
      pushToast("Chưa chọn điều kiện!", "error")
      return
    }
    const res = await mixGetV2(`/api/v1/be/insert_unique_data?data_migration=${idMigration}`)
    // if (res.status) {
    //   pushToast('Lưu dữ liệu thành công', "success")
    // } else {
    //   pushToast('Error', "warning")
    // }
  }

  return (
    <div className='pooling-data-auto'>
      {contextHolder}
      {/* <Helmet>
        <title>THACO AUTO CRM</title>
      </Helmet> */}
      <Layout>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: <Link to="/customer/pooling-data/customer-list">Danh sách khách hàng đã được làm sạch</Link>, },
            { title: 'Kiểm tra dữ liệu trùng theo điều kiện', },
          ]}
          title='Kiểm tra dữ liệu trùng theo điều kiện'

          backLink='/customer/pooling-data/customer-list'
          className='gutter-block-end'
        />

        {isStep === 3 &&
          <div className="his-total-list v2">
            <div className="his-one-item" style={{ backgroundImage: 'url("/images/bg-item.svg")' }}>
              <div className="title">Số khách hàng trùng lặp theo bộ điều kiện</div>
              <div className="count">{dasData.total_duplicate_groups ? formatNumber(dasData.total_duplicate_groups) : ''}</div>
            </div>
            <div className="his-one-item" style={{ backgroundImage: 'url("/images/bg-item.svg")', borderColor: '#F59C23' }}>
              <div className="title">Tỉ lệ trùng lặp theo bộ điều kiện</div>
              <div className="count">{dasData.percentage_of_total_customers ? `${formatNumber(dasData.percentage_of_total_customers)}%` : ''}</div>
            </div>
          </div>
        }

        {/* Fillter block */}
        <div className='filter-block filter-label-left t-mb-18'>
          <div className="title-dk">Bộ điều kiện</div>
          <div className='filter-select'>
            <div
              className='btn-select-show'
            >
              <span className="content-select" onClick={() => setActive(true)} >{isShowSelect}</span>
              <div
                className={`icon-down ${showSelectFilter ? "active" : ""}`}
                onClick={() => setActive(true)}
              >
                <DownOutlined />
              </div>
              <div
                className={`icon-close ${showSelectFilter ? "active" : ""}`}
                onClick={() => {
                  handleClearFilter('Chọn điều kiện');
                  setIdMigration(null);
                  setStep(1)
                  navigate('/customer/pooling-data/pooling-data-auto');
                }}
              >
                <CloseCircleOutlined />
              </div>
            </div>
            <div className={`list-filter ${showSelectFilter ? "active" : ""}`}>
              <div className="list-item">
                {listMigrations.map((val: any, index: any) => (
                  <div
                    key={index}
                    className="item-select"
                    onClick={() => {
                      handleClearFilter(val.label);
                      setIdMigration(val.value);
                      navigate(`?migration=${val.value}`);
                      setStep(1)
                    }}
                  >{val.label}</div>
                ))}
              </div>
            </div>
          </div>
          {isStep === 3 &&
            <div className="btn-custom-primary-outline" onClick={() => setActiveStep2()}>
              <div className="icon-svg"><ReloadOutlined /></div>
              <div className="text">Làm mới thông tin</div>
            </div>
          }
        </div>

        {isStep === 1 && (
          <div className="empty-data">
            <div className="img-box">
              <img src="/images/empty-image.svg" alt="img empty" />
            </div>
            <div className="sum">Chọn bộ điều kiện để kiểm tra trùng lặp</div>
            <div className="des">
              <div className="icon">
                <svg width="1em" height="1em" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.5 14.7143H4.21429C4.13571 14.7143 4.07143 14.7786 4.07143 14.8571V15.4286C4.07143 15.7446 4.32679 16 4.64286 16H8.07143C8.3875 16 8.64286 15.7446 8.64286 15.4286V14.8571C8.64286 14.7786 8.57857 14.7143 8.5 14.7143ZM6.35714 0C3.12321 0 0.5 2.62321 0.5 5.85714C0.5 8.025 1.67857 9.91786 3.42857 10.9304V13C3.42857 13.3161 3.68393 13.5714 4 13.5714H8.71429C9.03036 13.5714 9.28572 13.3161 9.28572 13V10.9304C11.0357 9.91786 12.2143 8.025 12.2143 5.85714C12.2143 2.62321 9.59107 0 6.35714 0ZM8.64107 9.81786L8 10.1893V12.2857H4.71429V10.1893L4.07321 9.81786C2.66786 9.00536 1.78571 7.50893 1.78571 5.85714C1.78571 3.33214 3.83214 1.28571 6.35714 1.28571C8.88214 1.28571 10.9286 3.33214 10.9286 5.85714C10.9286 7.50893 10.0464 9.00536 8.64107 9.81786Z" fill="#1890FF" />
                </svg>
              </div>
              <div className="text">Hệ thống sẽ tìm các dữ liệu khách hàng trùng lặp giữa các nguồn dữ liệu</div>
            </div>
            <div className='list-btn-actionV2'>
              <div className="btn-kttl" onClick={() => setActiveStep2()}>Kiểm tra trùng lặp</div>
              {/* <div className="btn-kttl" onClick={saveData}>Lưu dữ liệu không trùng</div> */}
            </div>
          </div>
        )}

        {isStep === 2 && (
          <div className="load-check-data">
            <div className="img-box">
              <img src="/images/bg-load-auto.png" alt="img check load" />
            </div>
            <div className="line-load">
              <div
                className="percent"
                style={{
                  width: '40%',
                }}
              />
            </div>
            <div className="sum">Hệ thống đang kiểm tra khách hàng trùng lặp theo hệ thống được thiết lập trong bộ điều kiện</div>
          </div>
        )}

        {isStep === 3 && (
          <div className="data-pooling-auto-list v2">
            {/* <div className="chart-pooling-block">
              <div className="img-box">
                <img src="/images/chart-auto-pooling.png" alt="img chart pooling" />
              </div>
              <div className="total-data-pooling">
                <div className="total-number">
                  <div className="title">Số KH trùng lặp giữa 3 hệ thống</div>
                  <div className="count">1000</div>
                  <div className="sum">khách hàng</div>
                </div>
                <div className="total-number">
                  <div className="title">Tỉ lệ trùng lặp giữa 3 hệ thống</div>
                  <div className="count pb-2">10%</div>
                </div>
              </div>
            </div> */}
            {/* <Button className="rs-button t-mb-18" onClick={() => saveData()}>
              <span>Lưu dữ liệu không trùng lặp</span>
            </Button> */}

            <div className="t-table-block t-table-pooling-data-auto-detail">
              {selectedRowKeys.length !== 0 &&
                <Flex align="center" gap="middle" className='ctrl-select-table'>
                  <div className="count-check-all">
                    Đã chọn
                    <div className="cl-096DD9">{selectedRowKeys.length} hàng</div>
                  </div>

                  <Button
                    onClick={() => deleteItems()}
                    className='delete-all'
                    disabled={listDataLoading}
                  >Xóa</Button>
                </Flex>
              }

              <MegaTable
                stData={{ ...megaTableData }}
                stChange={(data) => {
                  setMegaTableData((prev: any) => ({ ...prev, ...data }));
                }}
              />

              <div className="t-table-block t-table-customer c-table-scoll-x">
                <div className="pagination-block">
                  <Pagination
                    className='rs-pagination'
                    showSizeChanger
                    total={pagination.total}
                    defaultPageSize={pagination.pageSize}
                    current={pagination.current}
                    itemRender={(page, type, originalElement) => {
                      // Chỉ custom khi là nút số trang
                      if (type === 'page') {
                        return <span>{formatNumber(page)}</span>;
                      }
                      // prev / next / jump-prev / jump-next giữ nguyên
                      return originalElement;
                    }}
                    showTotal={() => `Tổng cộng ${Math.ceil(pagination.total / pagination.pageSize) === 0 ? 1 : Math.ceil(pagination.total / pagination.pageSize)} trang`}
                    locale={{ items_per_page: 'trang' }}
                    onChange={handleChangePagination}
                  />
                </div>
              </div>


            </div>

          </div>
        )}
      </Layout>

      <ModalDeleteManager
        isOpen={openDelete}
        title="Bạn có chắc chắn xóa những khách hàng này"
        titleDelete="Xóa khách hàng"
        content="Khách hàng và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
        closeModal={closeModalDelete}
        onConfirm={onConfirmDelete}
      />
      <ModalDeleteManager
        isOpen={openDeleteV2}
        title="Bạn có chắc chắn xóa những khách hàng này"
        titleDelete="Xóa khách hàng"
        content="Khách hàng và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
        closeModal={closeModalDeleteV2}
        onConfirm={() => onConfirmDeleteV2(0)}
      />
    </div>
  );
}

export default PoolingDataAutoDetail;
